import { render, staticRenderFns } from "./PerformanceDrawer.vue?vue&type=template&id=5ee06563&scoped=true"
import script from "./PerformanceDrawer.vue?vue&type=script&lang=js"
export * from "./PerformanceDrawer.vue?vue&type=script&lang=js"
import style0 from "./PerformanceDrawer.vue?vue&type=style&index=0&id=5ee06563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee06563",
  null
  
)

export default component.exports